import { actionUpdateAdminConfigMessages } from '../store'

const handleSubmit = async ({ messages }, { props: { submit } }) => {
  const adminConfigMessages = messages
  const action = actionUpdateAdminConfigMessages({ adminConfigMessages })
  await submit(action)
}

export default handleSubmit
